import { EMP_INFO_SYSTEM_NAME } from '../constants/StandardEmploymentInformationSystemName.js';
import type { TaetigkeitsBaseData } from '../enums/TaetigkeitsBaseData.js';

export function getIdentifikationscode(enumType: TaetigkeitsBaseData, bezeichnung: string): number {
  const taetigkeitsDataObj = enumType.find(td => td.Bezeichnung === bezeichnung);
  return taetigkeitsDataObj?.[EMP_INFO_SYSTEM_NAME] ?? 9;
}
